import { useEffect, useState } from "react";
import {
  connectWebSocket,
  subscribeToNotifications,
  onMessage,
  closeWebSocket,
} from "../services/webSocketService";
import { getNotifications } from "../services/userService";
import { wsServicesMapping } from "../utils/constants";
import { getEnvVariable } from "../utils/config";

const useWebSocket = (service, userId) => {
  const [notifications, setNotifications] = useState(0);
  const url = `${getEnvVariable("REACT_APP_WS_BASE_URL")}${wsServicesMapping[service]}`;

  // Fetch initial unread count via REST so the badge is correct on page load
  useEffect(() => {
    if (!userId) return;
    getNotifications(userId)
      .then((response) => {
        const unreadCount = response.data.filter((n) => !n.isRead).length;
        setNotifications(unreadCount);
      })
      .catch(() => {});
  }, [userId]);

  // WebSocket for real-time updates (centralized: only connect when user is logged in)
  useEffect(() => {
    if (!userId) return;
    connectWebSocket(url);
    subscribeToNotifications(userId);
    const handleMessage = (message) => {
      if (message.action === "new_notification")
        setNotifications((prev) => prev + 1);
      else if (message.action === "unviewed_notifications")
        setNotifications(message.notifications.length);
    };
    const unsubscribe = onMessage(handleMessage);
    return () => {
      unsubscribe();
      closeWebSocket();
    };
  }, [url, userId]);

  return { setNotifications, notifications };
};

export default useWebSocket;
